var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBusinessStrategyAndConsultancy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Workflow-Coaching-Plan--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Workflow Coaching Plan Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.89 2.17h-2.72a2.17 2.17 0 0 0 -4.34 0H7.11v2.21A1.08 1.08 0 0 0 8.2 5.46h7.6a1.08 1.08 0 0 0 1.09 -1.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 2.25h-1.77v1.5h1.77a0.27 0.27 0 0 1 0.27 0.27v18.21a0.27 0.27 0 0 1 -0.27 0.27H3.84a0.27 0.27 0 0 1 -0.27 -0.27V4a0.27 0.27 0 0 1 0.27 -0.27h1.77V2.25H3.84A1.78 1.78 0 0 0 2.07 4v18.23A1.77 1.77 0 0 0 3.84 24h16.32a1.77 1.77 0 0 0 1.77 -1.77V4a1.78 1.78 0 0 0 -1.77 -1.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38 14.12a3.44 3.44 0 1 0 3.44 3.44 3.45 3.45 0 0 0 -3.44 -3.44Zm0 5.38a1.94 1.94 0 1 1 1.94 -1.94 1.94 1.94 0 0 1 -1.94 1.94Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.68 11.17 1.54 -1.54a0.75 0.75 0 0 0 -1.06 -1.06l-1.54 1.54 -1.54 -1.54A0.75 0.75 0 0 0 14 9.63l1.54 1.54L14 12.71a0.75 0.75 0 0 0 1.06 1.06l1.54 -1.54 1.54 1.54a0.75 0.75 0 0 0 1.06 -1.06Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.61 8.84 -1.67 -1.67a0.75 0.75 0 0 0 -1.28 0.49l-0.05 1a5.71 5.71 0 0 0 -3.6 3 0.76 0.76 0 0 0 0.34 1 0.78 0.78 0 0 0 0.33 0.07 0.75 0.75 0 0 0 0.68 -0.42 4.26 4.26 0 0 1 2.16 -2.01l0 0.52a0.75 0.75 0 0 0 1.22 0.62L12.56 10a0.75 0.75 0 0 0 0 -1.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBusinessStrategyAndConsultancy);
export default ForwardRef;